<template>
  <div>
    <van-nav-bar
      title="亲友团"
      fixed
      :z-index="99"
      left-arrow
      @click-left="onClickLeft"
      :border="false"
    />
    <br />
    <br />
    <div class="ulBox" v-if="dataList != null && dataList.length > 0">
      <div class="listBox" v-for="(item, index) in dataList" :key="index">
        <div class="top">
          <img :src="item.HeadPic" />
          <div class="detial">
            <div class="nickName">
              昵称：{{ item.NickName }}
              <span v-if="index==0" :class="item.IsAdmin ? 'tag-1' : 'tag-2'">{{
                item.RelationText
              }}</span
              >&nbsp;
              <!-- <span class="tag-2" >朋友</span>&nbsp; -->
            </div>
            <div class="time">加入时间：{{ item.AddDateTime }}</div>
          </div>
        </div>
        <div class="bottom">
          <div class="eye">
            <!-- <van-icon name="eye-o" /> -->
            &nbsp;&nbsp;
          </div>
          <div
            @click="onReview(item.Id)"
            class="review"
            v-if="index > 0&&item.IsPass == 0&&item.IsEdit"
          >
            一键审核
          </div>
          <div  v-else-if="item.IsEdit" >
            <div v-html="GetState(item.IsPass)" ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty" v-else>
      <p>暂无数据！</p>
    </div>

    <van-dialog v-model="show" @confirm="onConfirm" show-cancel-button>
      <div>
        <van-radio-group class="reviewBox" v-model="radio">
          <van-radio name="1">通过</van-radio>
          <br />
          <van-radio name="2">不通过</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Toast } from "vant";
export default {
  data() {
    return {
      mid: "",
      show: false,
      radio: "1",
      selId: "",
      dataList: null,
      form: {
        type: "FrienMemberTeamPostState",
        id: "",
        state: "",
      },
    };
  },
  computed: {
    ...mapGetters(["currentMember"])
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetFrienMemberTeamList",
          mid: this.mid,
        })
        .then((res) => {
          //console.log(res,"GetFrienMemberTeamList")
          that.dataList = res.data;
        });
    },
    GetState(state) {
      var _text = "";
      switch (state) {
        case 1:
          _text = "<span style='color:green' >审核通过</span>";
          break;
        case 2:
          _text = "<span style='color:red' >审核驳回</span>";
          break;
      }
      return _text;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onReview(id) {
      this.selId = id;
      this.show = true;
    },
    onConfirm() {
      var that = this;
      console.log(this.selId, this.radio);
      Object.assign(this.form, {
        id: this.selId,
        state: this.radio,
      });
      this.$store.dispatch(this.form).then((res) => {
        Toast(res.Message);
        setTimeout(() => {
          if (res.IsSuccess) {
            that.init();
          }
        }, 1000);
      });
    },
  },
  created() {
    this.mid = this.$route.query.mid;
    this.init();
  },
};
</script>

<style lang="less" scoped>
.listBox {
  display: flex;
  flex-direction: column;
  padding: 10px;
  background-color: #f8f3f3;
  margin: 5px;
  border-radius: 8px;
  .top {
    display: flex;
    flex-direction: row;
    img {
      width: 50px;
      height: 50px;
      // object-fit: contain;
    }
    .detial {
      padding-left: 10px;

      .nickName {
        padding-bottom: 5px;
        .tag-1 {
          background-color: #267bf8;
          color: white;
          padding: 2px;
          border-radius: 5px;
        }
        .tag-2 {
          background-color: #fe0000;
          color: white;
          padding: 2px;
          border-radius: 5px;
        }
      }
      .time {
        color: silver;
      }
    }
  }
  .bottom {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 5px;
    .eye {
      display: flex;
      flex: 3;
      align-items: center;
    }
    .review {
      padding-right: 3px;
      background-color: #267bf8;
      color: white;
      padding: 5px;
      border-radius: 5px;
      font-size: 12px;
    }
  }
}

.reviewBox {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 15px;
}

.empty {
  text-align: center;
  font-size: 18px;
  font-weight: 800;
}
</style>
